import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/home';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
              <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-eye-line text-background-50 text-lg"></i>
              </span>
              <span className={`text-xl font-heading font-bold transition-colors duration-300 ${isScrolled ? 'text-foreground-950' : 'text-background-50'}`}>
                {siteConfig.logoText}
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === '/'
                    ? isScrolled ? 'text-primary-600 font-medium' : 'text-background-50 font-medium'
                    : isScrolled ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100' : 'text-background-50/80 hover:text-background-50'
                }`}
              >
                首页
              </Link>
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors duration-200 ${
                    location.pathname === `/category/${cat.slug}`
                      ? isScrolled ? 'text-primary-600 font-medium' : 'text-background-50 font-medium'
                      : isScrolled ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100' : 'text-background-50/80 hover:text-background-50'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <div className="relative group">
                <button className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap flex items-center gap-1 transition-colors duration-200 ${
                  isScrolled ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100' : 'text-background-50/80 hover:text-background-50'
                }`}>
                  更多
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </button>
                <div className="absolute top-full left-0 mt-1 w-36 bg-background-50 rounded-lg border border-background-200/70 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-1">
                  {categories.slice(4).map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-3 py-2 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className={`hidden md:flex items-center gap-1 px-3 py-2 text-sm whitespace-nowrap transition-colors duration-200 ${
                isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
            <Link
              to="/category/meiri-dasai"
              className={`hidden md:flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                isScrolled
                  ? 'bg-foreground-950 text-background-50 hover:bg-foreground-800'
                  : 'bg-background-50 text-foreground-950 hover:bg-background-100'
              }`}
            >
              <i className="ri-fire-line"></i>
              每日大赛
            </Link>
            <button
              className="md:hidden w-10 h-10 flex items-center justify-center"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`text-xl ${isScrolled ? 'text-foreground-950' : 'text-background-50'} ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 flex items-center gap-2"
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100">
              关于我们
            </Link>
            <Link
              to="/category/meiri-dasai"
              className="mt-2 px-4 py-2.5 rounded-full text-sm font-medium text-center bg-foreground-950 text-background-50"
            >
              <i className="ri-fire-line mr-1"></i>每日大赛
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}